<template>
    <div>
        <div class="modal" v-if="modal" @click="chose">
            <img :src="url" alt="">
        </div>
        <!-- <div class="chose">X</div> -->
    </div>
</template>

<script>
export default {
    props:{
        url:{
            type:String,
            default(){
                return ''
            }
        },
        modal:{
            type:Boolean,
            default(){
                return false
            }
        }
    },
    methods:{
        chose(){
            this.$emit('chose',false)
        }
    }
}
</script>

<style lang="scss" scoped>
    .modal{
        position: absolute;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999999;
        width: 87%;
        height: 100vh;
        background-color: rgba(0,0,0,0.6);
        .chose{
            position: absolute;
            top: 0;
            right: 0;
            width: 40px;
            height: 40px;
            background-color: red;
        }
      >img {
        width: auto;
        height: auto;
        max-width: 80%;
        max-height: 80%;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/modal.vue